import React, { useState } from 'react';
import { Segment } from 'tea-component';
import { defaultChannelList, metricsOptions } from '../../constants';
import TrendsInfo from '../widgets/TrendsInfo';
import ChannelsShareInfo from '../widgets/ChannelsShare';
import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import CardLoading from '@op/components/CardLoading';
import '@op/assets/scss/pages/community/index.scss';
import '@op/assets/scss/pages/community/streaming.scss';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import UserGuideCommunity from '@op/components/UserGuide/community';
import { getStreamingChannelLatestDate } from '@/pages/opinion/services/community';
import moment from 'moment';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import StreamingPoint from '@op/operationLog/pages/streaming';

function StreamingOverview({ gameInfo, wholeGameInfo }: any) {
  const { loading, changeFilter, filter, scrollBody, filterOptions } =
    useFilterDataHook({
      pageName: 'Community_Streaming',
      gameInfo,
    });
  const [metric, setMetric] = useState('hoursWatched');
  const { formatOptionsMessage } = useLanguage();
  useInitBuriedPointInfo({ buriedPoint: StreamingPoint });

  return (
    <>
      <FilterFixed
        scrollBody={scrollBody}
        operateShowOptions={null}
        filter={filterOptions}
        isTile
        selectDefaultOptions={{
          channel: {
            social: defaultChannelList,
          },
        }}
        beforeCacheDealwithData={(cache) => {
          // 不缓存渠道信息
          const { channel, channel_type, ...otherInfo } = cache || {};
          return { ...otherInfo, channel_social: channel };
        }}
        finallyDealwithDefaultValue={async (defaultValue) => {
          // 默认值处理，将渠道信息处理为空数组
          const { start_time, end_time, date_type } = defaultValue;
          const channelListValue = [...defaultChannelList].map(
            (item) => `social@${item}`,
          );
          defaultValue.channel =
            defaultValue?.channel?.filter((item: string) =>
              channelListValue.includes(item),
            ) || [];
          try {
            // 如果默认时间不是当天，那么就直接过，否则就请求接口获取数据
            if (
              start_time &&
              moment(start_time).format('YYYY-MM-DD') !==
                moment().format('YYYY-MM-DD')
            ) {
              defaultValue.date_type =
                date_type === 'hourly' ? 'daily' : date_type;
            } else if (gameInfo.edition_unified_id) {
              const data: any = await getStreamingChannelLatestDate({
                ...gameInfo,
                start_time: start_time,
                end_time: end_time,
                date_type: date_type,
                channels: defaultChannelList,
                source: 'channel',
                metric: metric,
              });
              if (data) {
                const { start_time: serverStartTime, end_time: serverEndTime } =
                  data;
                defaultValue.date_type = 'daily';
                defaultValue.start_time = serverStartTime
                  ? moment(serverStartTime).format('YYYY-MM-DD')
                  : start_time;
                defaultValue.end_time = serverEndTime
                  ? moment(serverEndTime).format('YYYY-MM-DD')
                  : start_time;
              }
            }
          } catch (error) {}
          return defaultValue;
        }}
        defaultConfig={{
          channel: { channelKey: 'social' },
          date: { dateTypeList: ['date', 'week', 'month'] },
        }}
        confirm={(value: any) => {
          const { channel, ...otherInfo } = value || {};

          changeFilter({
            channels: channel,
            ...otherInfo,
            ...gameInfo,
          });
        }}
      ></FilterFixed>
      <CardLoading loading={loading}>
        <UserGuideCommunity></UserGuideCommunity>

        <Segment
          value={metric}
          className="segment-light"
          onChange={(value) => setMetric(value)}
          options={formatOptionsMessage(metricsOptions)}
        />

        <TrendsInfo
          params={filter}
          gameInfo={gameInfo}
          metric={metric}
          channelList={defaultChannelList}
        ></TrendsInfo>
        <ChannelsShareInfo
          gameName={wholeGameInfo.entity_name}
          gameInfo={gameInfo}
          params={filter}
          metric={metric}
          showTitleTips={!wholeGameInfo.is_expanded}
        ></ChannelsShareInfo>
      </CardLoading>
    </>
  );
}

export default StreamingOverview;
